// extracted by mini-css-extract-plugin
export default {"wrapper":"NGl_P","content":"XN_wF","title":"lRJGj","subtitle":"K7AXG","imageWrapper":"LxdLA","image":"iOJvi","cnImage":"jv7O_"};